import { render } from "./ChangeExcess.vue?vue&type=template&id=25f71fa9&scoped=true"
import script from "./ChangeExcess.vue?vue&type=script&lang=js"
export * from "./ChangeExcess.vue?vue&type=script&lang=js"

import "./ChangeExcess.vue?vue&type=style&index=0&id=25f71fa9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f71fa9"]])

export default __exports__